import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LocaleInterceptor {
  constructor(private translateService: TranslateService) {
    if (!this.translateService.currentLang) {
      this.translateService.currentLang = localStorage.getItem('language')
        ? localStorage.getItem('language')
        : 'en';
    }
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    req = req.clone({
      setHeaders: { 'Accept-Language': this.translateService.currentLang }
    });
    return next.handle(req).pipe() as any;
  }
}
